import * as React from "react";
import { HudActionButton } from "../../hud-action-button/HudActionButton";
import { HudCollectEvent } from "../../hud-collect-event/HudCollectEvent";
export var BF2HudLeftTop = function () { return (React.createElement("div", { className: "hud-button__buttons-container" },
    React.createElement(HudActionButton, null),
    React.createElement(HudCollectEvent, null))); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudLeftTop.tsx
// module id = 2285
// module chunks = 3